import React from "react";
import { HashLink } from "react-router-hash-link";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const Periodontics = () => {
  const { t, i18n } = useTranslation();

  const seo = t("periodontics.seo", { returnObjects: true });
  const whatList = t("periodontics.whatList", { returnObjects: true });
  const symptomsList = t("periodontics.symptomsList", { returnObjects: true });
  const servicesList = t("periodontics.servicesList", { returnObjects: true });
  const riskList = t("periodontics.riskList", { returnObjects: true });
  const whyList = t("periodontics.whyList", { returnObjects: true });

  return (
    <div
      className="container py-5 mt-5"
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
    >
      <Helmet>
        <link
          rel="canonical"
          href="https://saleemsmile.com/articles/gum-diseases"
        />

        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta property="og:title" content={seo.ogTitle} />
        <meta property="og:description" content={seo.ogDescription} />
        <meta property="og:image" content={seo.ogImage} />
        <meta property="og:type" content="article" />
        <meta
          property="og:locale"
          content={i18n.language === "ar" ? "ar_AR" : "en_US"}
        />
      </Helmet>

      <h1 className="mb-4 text-center" style={{ color: "#00b3ff" }}>
        {t("periodontics.title")}
      </h1>
      <h5 className="text-center mb-5">{t("periodontics.subtitle")}</h5>
      <p className="text-center text-muted">{t("periodontics.tagline")}</p>

      <h2 className="mt-4">{t("periodontics.whatTitle")}</h2>
      <p>{t("periodontics.whatText")}</p>
      <ul>
        {whatList.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <h2 className="mt-4">{t("periodontics.symptomsTitle")}</h2>
      <ul>
        {symptomsList.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <h2 className="mt-4">{t("periodontics.servicesTitle")}</h2>
      <ul>
        {servicesList.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <h2 className="mt-4">{t("periodontics.riskTitle")}</h2>
      <ul>
        {riskList.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <h2 className="mt-4">{t("periodontics.whyTitle")}</h2>
      <ul>
        {whyList.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <h2 className="mt-4">{t("periodontics.messageTitle")}</h2>
      <p>
        <em>{t("periodontics.messageText")}</em>
      </p>

      <footer className="mt-4">
        <HashLink to="/#services" className="btn btn-outline-secondary">
          {i18n.language === "ar" ? "العودة للخدمات" : "Back to Services"}
        </HashLink>
      </footer>
    </div>
  );
};

export default Periodontics;
